<template lang="">
  <el-dialog
    title="权限复制"
    :visible="isShow"
    width="600px"
    destroy-on-close
    :before-close="closeDialog"
  >
    <el-form ref="formDataRef" :inline="true" :model="formData" :rules="rules">
      <el-form-item label="复制姓名：" prop="businessName">
        <el-input v-model="formData.businessName" clearable placeholder="请输入复制的姓名" />
      </el-form-item>
    </el-form>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="userName" label="姓名" align="left" />
      <el-table-column prop="areaName" label="区域名称" align="left" />
      <el-table-column prop="deptName" label="部门名称" align="left" />
      <el-table-column label="操作" fixed="right" align="left">
        <template v-slot="{$index}">
          <el-button type="text" @click="deleteRowData($index)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="footer-btn">
      <el-button @click="closeDialog">
        取消
      </el-button>
      <el-button type="primary" :disabled="!tableData.length" :loading="isLoading" @click="submitFormData">
        确认复制
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { copyBusinessShip } from '@/API';

export default {
  data () {
    return {
      isShow: false,
      isLoading: false,
      formData: {},
      tableData: [],
      rules: {
        businessName: [
          { required: true, message: '请输入复制的姓名', trigger: 'blur' }
        ]
      }
    };
  },

  methods: {
    openDialog (val) {
      this.isShow = true;
      this.tableData = val;
    },

    closeDialog () {
      this.isShow = false;
      this.formData = {};
      this.tableData = [];
    },

    deleteRowData (index) {
      this.tableData.splice(index, 1);
    },

    submitFormData () {
      this.$refs.formDataRef.validate((state) => {
        if (state) {
          let params = {
            ...this.formData,
            businessAreaDeptRelationshipList: this.tableData.map(row => {
              let { userName, areaId, areaName, deptCode, deptName } = row;
              return { userName, areaId, areaName, deptCode, deptName };
            })
          };

          this.isLoading = true;
          copyBusinessShip(params)
            .then(res => {
              const { status, data } = res.data;
              this.isLoading = false;
              if (status === '200' && data) {
                this.$emit('on-ok');
                this.$message.success('复制成功');
                this.closeDialog();
              }
            }).catch(() => {
              this.isLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style scope>
.btn-style {
  margin-bottom: 12px;
}
.footer-btn {
  display: block;
  margin-top: 15px;
  text-align: right;
}
</style>
